import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { INDIAN_LANGUAGES } from '../utils/states';

const Layout = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const [language, setLanguage] = useState('en');
  const [showLangMenu, setShowLangMenu] = useState(false);

  const navLinks = [
    { path: '/', label: 'Home' },
    { path: '/about', label: 'About' },
    { path: '/privacy', label: 'Privacy & Security' },
    { path: '/terms', label: 'Terms & Conditions' },
    { path: '/contact', label: 'Contact Us' },
  ];

  const handleLogout = async () => {
    await logout();
    navigate('/');
  };

  return (
    <div className="min-h-screen bg-black text-white">
      <header className="fixed top-0 left-0 right-0 z-50 backdrop-blur-2xl bg-black/60 border-b border-white/10">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="flex items-center justify-between h-20">
            <Link to="/" className="flex items-center" data-testid="logo-link">
              <img
                src="https://customer-assets.emergentagent.com/job_donor-connect-hub-2/artifacts/urb11myp_cf61f971-770e-4673-bd11-3305f0999f09.png"
                alt="MyGaadiNumber"
                className="h-14"
              />
            </Link>

            <nav className="hidden lg:flex items-center gap-6">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  data-testid={`nav-link-${link.label.toLowerCase().replace(/\\s+/g, '-')}`}
                  className={
                    location.pathname === link.path
                      ? 'text-[#FF3B30] text-sm font-medium tracking-wide'
                      : 'text-[#A1A1A6] hover:text-white text-sm font-medium tracking-wide transition-colors'
                  }
                >
                  {link.label}
                </Link>
              ))}
            </nav>

            <div className="flex items-center gap-4">
              <div className="relative">
                <button
                  onClick={() => setShowLangMenu(!showLangMenu)}
                  data-testid="language-selector"
                  className="px-4 py-2 bg-white/10 hover:bg-white/20 rounded-full text-sm font-medium transition-all flex items-center gap-2"
                >
                  <span>🌐</span>
                  <span>{INDIAN_LANGUAGES.find(l => l.code === language)?.name.split(' ')[0] || 'EN'}</span>
                </button>
                {showLangMenu && (
                  <div className="absolute top-12 right-0 bg-[#121214] border border-white/10 rounded-xl p-2 min-w-[200px] shadow-2xl z-50">
                    {INDIAN_LANGUAGES.map((lang) => (
                      <button
                        key={lang.code}
                        onClick={() => {
                          setLanguage(lang.code);
                          setShowLangMenu(false);
                        }}
                        className={`w-full text-left px-4 py-2 rounded-lg text-sm transition-colors ${
                          language === lang.code
                            ? 'bg-[#FF3B30] text-white'
                            : 'hover:bg-white/10 text-[#A1A1A6]'
                        }`}
                      >
                        {lang.name}
                      </button>
                    ))}
                  </div>
                )}
              </div>

              {user && user._id ? (
                <>
                  <Link
                    to="/dashboard"
                    data-testid="dashboard-link"
                    className="px-6 py-2.5 bg-white/10 hover:bg-white/20 rounded-full text-sm font-medium transition-all"
                  >
                    Dashboard
                  </Link>
                  <button
                    onClick={handleLogout}
                    data-testid="logout-button"
                    className="px-6 py-2.5 bg-[#FF3B30] hover:bg-[#E3242B] rounded-full text-sm font-medium transition-all"
                  >
                    Logout
                  </button>
                </>
              ) : (
                <Link
                  to="/login"
                  data-testid="login-link"
                  className="px-6 py-2.5 bg-[#FF3B30] hover:bg-[#E3242B] rounded-full text-sm font-medium transition-all"
                >
                  Login
                </Link>
              )}
            </div>
          </div>
        </div>
      </header>

      <main className="pt-20">{children}</main>

      <footer className="bg-[#0A0A0B] border-t border-white/10 py-12">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="flex flex-col md:flex-row justify-between items-center gap-6">
            <div className="flex items-center">
              <img
                src="https://customer-assets.emergentagent.com/job_donor-connect-hub-2/artifacts/urb11myp_cf61f971-770e-4673-bd11-3305f0999f09.png"
                alt="MyGaadiNumber"
                className="h-10"
              />
            </div>
            <p className="text-[#86868B] text-sm">
              © 2026 MyGaadiNumber. All rights reserved.
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Layout;
